import React, { useContext } from "react";
import Close from "../../../../Helpers/CloseBtn/Close";
import { popupcontext } from "../../../../../context/Popupscontext";
import { useSelector } from "react-redux";
import { useMap } from "react-leaflet";
import trans from "../../../../../utils";
import {  useGetUserGroupQuery } from "../../../../../Redux/service/Groups/Groups";

export default function ObjectUsersHead() {
	let { handleClose } = useContext(popupcontext);
	const inf = useSelector((state) => state.users.user);
	const { data: AllUsers } = useGetUserGroupQuery(inf?.id, { skip: !inf?.id });
	const Branches = AllUsers?.filter(
		(user) => user.administrator === false && user.userLimit > 0
	);
	const map = useMap();
	return (
		<>
			<div className="flex-between sticky p-16">
				<div className="d-flex">
					<div className="fs-16 fw-600 mx-2">{trans("Available Groups")}</div>
					<div className="users-availability">
						<div className="users-count">
							{AllUsers?.length ? AllUsers?.length : "-"}
						</div>
					</div>
				</div>
				<div className="close">
					<Close
						img="Close"
						close={() => {
							handleClose("objectUsers");
							map.dragging.enable();
						}}
					/>
				</div>
			</div>
			<div className="H-line"></div>
		</>
	);
}
